<template>
  <timeline-item :type="type" :date="object.date">
    <template v-slot:body>
      <div>
        <div class="d-flex align-items-center">
          <span class="m-badge m-badge--wide flex-shrink-0" :class="badgeClass">
            <span v-if="object.operation === 'Dodanie'">+</span>
            <span v-else>-</span>&nbsp;{{ object.points }}&nbsp;{{pointsSymbol}}
          </span>
          <div v-if="object.opinion && object.opinion.hasOwnProperty('stars')"
               class="stars-link-container flex-shrink-0 ml-2">
            <a href="#" class="start-link"
               @click="showOpinionModal({
                       operationId: object.id,
                       opinion: object.opinion
                     })">
                    <span v-for="x in 5" :key="x" class="fa fa-star"
                          :class="{[`font-ls`]: x <= object.opinion.stars}"></span>
            </a>
          </div>
        </div>
        <div class="mt-2">
          {{ info }}
        </div>
      </div>
    </template>
    <template v-slot:actions v-if="object.opinion === false">
      <button class="btn btn-sm m-btn m-btn--pill m-btn--custom btn-outline-ls"
              @click="showOpinionModal({
                            operationId: object.id,
                            opinion: null
                          })">Dodaj ocenę
      </button>
    </template>
  </timeline-item>
</template>

<script>
import TimelineItem from "@/components/timeline/TimelineItem";
import {mapActions, mapState} from "vuex";

export default {
  name: "PointsTimelineItem",
  props: {
    object: Object
  },
  components: {
    TimelineItem
  },
  methods: {
    ...mapActions([
      'showOpinionModal'
    ]),
  },
  computed: {
    ...mapState({
      showLocation: state => state.settings.showPointsLocation,
      opinionsEnabled: state => state.settings.operationsOpinionsEnabled === '1',
      pointsConfig: state => state.settings.points,
      pointsSymbol() {
        return this.pointsConfig.symbol ? this.pointsConfig.symbol : 'pkt.';
      },
      pointsName() {
        return this.pointsConfig.name ? this.pointsConfig.name : 'punkty';
      }
    }),
    type() {
      if (this.showLocation && this.object.shop !== '-') {
        return this.object.shop
      }

      return '';
    },
    badgeClass() {
      return {
        'm-badge--danger': this.object.operation === 'Odjęcie',
        'm-badge--success': this.object.operation === 'Dodanie'
      }
    },
    info() {
      if (this.object.info) {
        return this.object.info;
      }

      if (this.object.award) {
        return this.object.award;
      }

      if (this.object.document) {
        return this.object.document;
      }

      if ('Odjęcie' === this.object.operation) {
        return 'Zmniejszenie stanu konta';
      }

      return 'Zwiększenie stanu konta';
    }
  },
}
</script>

<style scoped>
.stars-link-container {
  width: 90px;
}

.start-link {
  color: lightgray;
}

.start-link:hover {
  color: #bababa;
}
</style>
